type MatterSortParts = {
	matterName?: string | null;
	client?: string | null;
	matterNumber?: string | null;
};

const COLLATOR = new Intl.Collator(undefined, {
	numeric: true,
	sensitivity: "base",
});

function normalize(value: string | null | undefined): string {
	return value?.trim() ?? "";
}

function compareText(
	a: string | null | undefined,
	b: string | null | undefined,
) {
	return COLLATOR.compare(normalize(a), normalize(b));
}

export function compareMatterSortParts(
	a: MatterSortParts,
	b: MatterSortParts,
): number {
	return (
		compareText(a.matterName, b.matterName) ||
		compareText(a.client, b.client) ||
		compareText(a.matterNumber, b.matterNumber)
	);
}
